import "../chunk-D57E6H3M.mjs";

// src/utils/getInitials.ts
var IDEOGRAPHIC = /^[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}\p{Script=Bopomofo}]/u;
var segmenter;
function graphemes(text) {
  if (segmenter === void 0) {
    segmenter = typeof Intl !== "undefined" && typeof Intl.Segmenter === "function" ? new Intl.Segmenter(void 0, { granularity: "grapheme" }) : null;
  }
  return segmenter ? Array.from(segmenter.segment(text), (part) => part.segment) : Array.from(text);
}
function firstGrapheme(word) {
  return graphemes(word)[0] ?? "";
}
function getInitials(name, locale) {
  let text = name.trim();
  const at = text.indexOf("@");
  const isEmail = at > 0 && !/\s/.test(text);
  if (isEmail) {
    text = text.slice(0, at).split("+")[0];
  }
  const words = text.split(isEmail ? /[._-]+/ : /\s+/).filter(Boolean);
  if (words.length === 0) {
    return "";
  }
  const first = firstGrapheme(words[0]);
  if (IDEOGRAPHIC.test(first)) {
    return first;
  }
  const last = words.length > 1 ? firstGrapheme(words[words.length - 1]) : "";
  return (first + last).toLocaleUpperCase(locale);
}
export {
  getInitials
};
//# sourceMappingURL=getInitials.mjs.map